import { render } from "./InputData.vue?vue&type=template&id=7284462d"
import script from "./InputData.vue?vue&type=script&lang=js"
export * from "./InputData.vue?vue&type=script&lang=js"

import "./InputData.vue?vue&type=style&index=0&id=7284462d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__